import { ParsedBboxes } from "api/utility-bills/types";

export function parseBboxes(bboxes: string | null | undefined): ParsedBboxes | null {
  if (!bboxes) return null;
  try {
    return JSON.parse(bboxes) as ParsedBboxes;
  } catch {
    return null;
  }
}
